var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.77884 0.679911C6.08516 -0.226578 7.36727 -0.226576 7.67358 0.679914L8.59792 3.41532C8.73523 3.82167 9.11638 4.09519 9.5453 4.09519H12.4505C13.4287 4.09519 13.8251 5.35476 13.0232 5.91496L10.7412 7.50918C10.3769 7.76369 10.2242 8.22808 10.3665 8.64909L11.2539 11.2753C11.5629 12.1897 10.5252 12.968 9.73387 12.4152L7.2989 10.7141C6.95492 10.4738 6.4975 10.4738 6.15352 10.7141L3.71855 12.4152C2.92727 12.968 1.88948 12.1897 2.19849 11.2753L3.08592 8.64909C3.22819 8.22808 3.07555 7.76369 2.71124 7.50918L0.42921 5.91496C-0.372686 5.35476 0.0237074 4.09519 1.0019 4.09519H3.90713C4.33604 4.09519 4.71719 3.82166 4.8545 3.41532L5.77884 0.679911Z",
    fill: "#00D25D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.08a55017503d82d49a4228b8c1cfae84.svg";
export { ForwardRef as ReactComponent };